import { useContext, useEffect, useState } from "react"
import { ApiGetCall, ApiPostCall } from "../../JS/Connector";
import { compressImage, convertToBase64, getUrlParameter, isValidEmail, typewatch, LogInSchoolID, getTypeWatchDelay } from "../../JS/Common";
import AlertsComp from "../../Components/AlertsComp";
import { StaffAddUpdate } from "./addupdate";
import { createContext } from "react";
import { CheckValidation, ValidateFile } from "../../Components/Validations";
import { useNavigate } from "react-router-dom";
import PageHead from "../../Components/PageHead";
import Popup from "../../Components/Popup";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { log } from "../../JS/Logger";
import { UserContext } from "../../App";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";

export const staffdetailscontent = createContext();
export function StaffMemberIndex() {
    const { dynamic_brand_text } = useConfig();
    const navigate = useNavigate();
    const [allData, setAllData] = useState({
        firstname: "",
        lastname: "",
        access: 0,
        email: "",
        flag: 1,
        Memberid: 0,
        SortbyFlag: 'asc',
        searchstring: '',
        File: null,
        skey: null,
    });
    const { UserData } = useContext(UserContext);
    const StateData = useSelector((state) => state.authData);
    var CsvUserId = StateData.csvUserID;
    const [AccessDevice, setAccessDevice] = useState([]);
    const [EmailError, setEmailError] = useState("");
    const [Users, setUsers] = useState([]);
    const [Alerts, setAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [ErrorForInvaid, setErrorForInvaid] = useState('');
    const [isaddupadtepopup, setIsaddupadtepopup] = useState(false);
    const [isDomainpopup, setIsDomainpopup] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const showPagination = Users.length > 0;
    const [columnNames, setColumnNames] = useState([]);
    const [selectedIdsAll, setSelectedIdsAll] = useState([]);
    const [SelectedItems, setSelectedItems] = useState([]);
    const [CreateGroupModal, setCreateGroupModal] = useState(false)
    const [CreateBatchbuttonVisible, setCreateBatchbuttonVisible] = useState(false)
    const [groupName, setGroupName] = useState('')
    const [grpErrorMsg, setGrpErrorMsg] = useState(false);
    const [showAddNewDomain, setShowAddNewDomain] = useState({
        newDomains: [],
        newDomainString: "",
    })
    useEffect(() => {
        GetAccessDevice(allData.skey ? allData.skey : null, allData.searchstring ? allData.searchstring : null, false);
        if (getUrlParameter("flag") == "1") {
            setTimeout(function () {
                setAllData({ ...allData, access: 2 });
            }, 500);
        }
    }, [currentPage, LimitForPagination]);
    async function GetAccessDevice(skey, searchstring, toogleSort) {
        if (!searchstring) searchstring = null;
        if (skey && toogleSort) allData.SortbyFlag = allData.SortbyFlag == "asc" ? "desc" : "asc";
        setAllData({ ...allData, skey: skey });
        var joinedString = null;
        if (columnNames.length > 0) {
            joinedString = columnNames.filter(name => name !== 'avatar').join('~');
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/staff-members/all?schoolId=${LogInSchoolID}&search=${searchstring}&sortBy=${skey}&sortOrder=${allData.SortbyFlag}&page=${currentPage}&perPage=${LimitForPagination}&data=${joinedString}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.pagination?.total || 0);
                    const sortedAccess = responseRs?.access?.sort((a, b) => a.name.localeCompare(b.name))
                    setAccessDevice(sortedAccess);
                    setUsers(responseRs.msg.length ? responseRs.msg : [])
                    const allowedDomainsArray = responseRs?.all_domains?.split(',');
                    setShowAddNewDomain({ ...showAddNewDomain, newDomains: allowedDomainsArray || [], newDomainString: "" })
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }
    async function AddUpdateStaffMember(flag) {
        if (!allData.email || allData.email.trim() === "") {
            setEmailError("*required");
            isFormValid = false;
        } else if (!isValidEmail(allData.email)) {
            setEmailError("Invalid Email");
            isFormValid = false;
        } else {
            setEmailError("");
        }
        var isFormValid = CheckValidation({ formID: 'UserForm' });
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            firstName: allData.firstname,
            lastName: allData.lastname,
            accessId: allData.access,
            schoolId: LogInSchoolID,
            email: allData.email,
            uuid: allData.Memberid,
            profile: allData.File,
            currentUserId: CsvUserId
        });
        await ApiPostCall("/users/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setAlerts("");
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var msg = flag == 1 ? 'Member Added Successfully.' : 'Member Updated Successfully.';
                    setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        setIsaddupadtepopup(false)
                        GetAccessDevice(null, null);
                        setAllData({ ...allData, firstname: '', lastname: '', email: '', flag: 1, access: 0, Memberid: 0, File: '' })
                    }, 2500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 3500);
                }
            }
        });
    }
    async function CreateGroupCall() {
        const joinedIds = selectedIdsAll.join(',');
        if (selectedIdsAll.length < 2) {
            setGrpErrorMsg(true)
            return
        }
        var isFormValid = CheckValidation({ formID: 'Staffmembergroup' });
        if (!isFormValid) return;
        setLoading(true);

        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            groupName: groupName,
            groupUserId: selectedIdsAll,
            groupId: 0
        });
        await ApiPostCall("/helpdesk/groups/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result)
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Group Created Successfully"} />);
                    setCreateGroupModal(false);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        if (!UserData.helpdeskUpdatedFlag) {
                            navigate("/ticket-assignments")
                        } else {
                            navigate("/helpdesk-ticket-assignments", { state: { openUserGroups: true } });
                        }
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }
    function handleSearchChange(e) {
        setCurrentPage(1);
        GetAccessDevice(null, e.target.value, false)
        setAllData({ ...allData, searchstring: e.target.value });
    }
    async function handleFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            setAlerts(<AlertsComp show={true} variant="danger" msg={validationMsg} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />)
            }, 2000);
            return;
        }
        try {
            const compressedImg = await compressImage(file);
            const base64 = await convertToBase64(compressedImg);
            setAllData({ ...allData, File: base64 });
        } catch (error) {
            log.error("Error converting file to base64:", error);
            setErrorForInvaid("There was an error uploading the file. Please try again.");
        }
    };
    const modalBody = (
        <div className="row parent" id="UserForm">
            <div className='col-12 py-2'>
                <div className='FormLabel'>First Name<label className='redText'>*</label></div>
                <input type="text" name='firstname' autoComplete="off" className="form-control" required value={allData.firstname}
                    onChange={(e) => setAllData({ ...allData, firstname: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 py-2'>
                <div className='FormLabel'>Last Name<label className='redText'>*</label></div>

                <input type="text" name='firstname' autoComplete="off" className="form-control" required value={allData.lastname}
                    onChange={(e) => setAllData({ ...allData, lastname: e.target.value })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className="col-12 py-2">
                <div className='FormLabel'>Access<label className='redText'>*</label></div>

                <select required value={allData.access} onChange={(e) => setAllData({ ...allData, access: e.target.value })}>
                    <option value="0">Select</option>
                    {AccessDevice.map((item, i) => {
                        return <option value={item.id} key={i} title={item.defination} >{item?.name} </option>
                    })}
                </select>
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 py-2'>
                <div className='FormLabel'>Email<label className='redText'>*</label></div>

                <input type="email" name='Email' autoComplete="off" className="form-control " value={allData.email}
                    onChange={(e) => setAllData({ ...allData, email: e.target.value })} />
                <span className="Emailinvalid">
                    {EmailError}
                </span>
            </div>
            <div className="col-12 py-2 row">
                <div className='col-12 text-start shipdevice-font-style'>Upload Profile Picture</div>
                <div className="col-md-9 pt-2">
                    <form className="col-12">
                        <input type="file" label="Image" name="profilepicture" accept=".jpg,.png,.jpeg"
                            id="UploadFileId" onChange={(e) => handleFileUpload(e)} />
                        <label className="ImportInventoryBtn col-md-8 col-9" htmlFor="UploadFileId">Upload Profile Picture</label>
                        <label className="ImportInventoryBtn1 col-md-4 col-3 text-center" htmlFor="UploadFileId" style={{ color: "white" }}>
                            Browse
                        </label>
                    </form>
                </div>
                <div className="col-md-3 text-center ">
                    {allData.File &&
                        <>
                            <img src={allData.File} style={{ height: "100px", width: "100px" }} />
                            <img src="/images/DeleteIcon.svg" className="cursor-pointer mt-2" onClick={(e) => setAllData({ ...allData, File: null })} />
                        </>
                    }
                </div>
            </div>
            <div className="col-md-12 redText">{ErrorForInvaid}</div>
        </div>
    );
    const creategroupmodalbody = (
        <div id="Staffmembergroup" className="parent">
            <div className='col-12'>
                <div className='FormLabel'>Group Name<label className='redText'>*</label></div>
                <input className="form-control" autoComplete='off' name='building' required
                    value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            {grpErrorMsg == true && (
                <label className="Emailinvalid">Minimum two members are required</label>
            )}
        </div>
    );
    const domainmodalbody = (
        <div id="AllowedDomainDiv" className="parent">
            <div className="row">
                <div className='col-md-10 pe-0'>
                    <input
                        type="text"
                        className='form-control'
                        placeholder='Enter Domain'
                        onChange={(e) => !e.target.value.includes("@") && setShowAddNewDomain({ ...showAddNewDomain, newDomainString: e.target.value?.replace(/\s+/g, "")?.replace(/@/g, "") })}
                        value={showAddNewDomain.newDomainString}
                    />
                </div>
                <div className="col-md-2">
                    <label
                        className='BorderBtn h-100'
                        style={{ marginRight: '0', padding: '2px 8px 2px 8px' }}
                        title="Add Domain"
                        onClick={() => {
                            if (showAddNewDomain?.newDomainString?.trim() != "") {
                                setShowAddNewDomain({
                                    ...showAddNewDomain, newDomainString: "",
                                    newDomains: showAddNewDomain.newDomains.includes(showAddNewDomain.newDomainString?.trim()) ? showAddNewDomain.newDomains : [...showAddNewDomain.newDomains, showAddNewDomain.newDomainString]
                                })
                            }
                        }}
                    >
                        <img src="/images/helpdeskcategoryadd.svg" alt="" style={{ height: "25px" }} />
                    </label>
                </div>
                {showAddNewDomain?.newDomains?.map((item, i) => (
                    <div className="my-2 w-auto pe-0" key={i}>
                        <div
                            className="BorderBtn me-0"
                        >
                            <label className="me-2">
                                {item}
                            </label>
                            <span title="Remove Domain">
                                <FontAwesomeIcon icon={faXmark} size="lg" className="cursor-pointer" onClick={(e) => setShowAddNewDomain((prevState) => ({
                                    ...prevState,
                                    newDomains: prevState.newDomains?.filter((domain) => domain != item),
                                }))} />
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
    async function handleAllowedDomain() {
        var isFormValid = CheckValidation({ formID: 'AllowedDomainDiv' });
        if (!isFormValid) return;
        setLoading(true);

        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            domains: showAddNewDomain?.newDomains?.join(),
        });
        await ApiPostCall("/schools/domains/add", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Domains Updated Successfully"} />);
                    setShowAddNewDomain({ ...showAddNewDomain, newDomains: [], newDomainString: "", });
                    setIsDomainpopup(false);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                        GetAccessDevice(null, null, false);
                    }, 1500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }
    return (
        <staffdetailscontent.Provider value={{ allData, setAllData }}>
            {Alerts}
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={`${dynamic_brand_text} Users`} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="container-fluid px-0 mt-2">
                <div className="GridBox px-3 py-2">
                    <div className="row">
                        <div className='row my-2 d-flex justify-content-between pe-0 align-items-center'>
                            <div className="col-md-2">
                                <label className="blueText">*Main Admin</label>

                            </div>
                            <div className='col-md-10 ps-0 text-center d-md-flex justify-content-end align-items-center'>
                                <label className="pe-2 cursor-pointer text-decoration-underline" onClick={(e) => navigate('/roles')}>Go To Roles</label>
                                {CreateBatchbuttonVisible == true && (
                                    <button className="BorderBtn py-2 cursor-pointer" id='createdBatchbutton' onClick={(e) => setCreateGroupModal(true)}>
                                        Create Group <img src="/images/AddInventory.svg" className="img-fluid pe-2" /></button>
                                )}
                                <Dropdown className="me-2">
                                    <Dropdown.Toggle
                                        title="Add Allowed Domains"
                                        style={{ backgroundColor: "#F9FAFB", color: "black", textAlign: 'left', border: "1px solid #E2E3E4", borderRadius: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        Allowed Domains
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu style={{ width: "100%" }}>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            {showAddNewDomain.newDomains?.map((option, i) => (
                                                <Dropdown.Item key={i}>
                                                    {option}
                                                </Dropdown.Item>
                                            ))}
                                            <Dropdown.Item>
                                                <label
                                                    className=" cursor-pointer text-white w-100 text-center d-flex align-items-center justify-content-center"
                                                    style={{ borderRadius: "10px", background: "var(--primary-color)", padding: "3px 13px" }}
                                                    onClick={() => setIsDomainpopup(true)}
                                                    title="Add Allowed Domains"
                                                >
                                                    Add More
                                                    <img src='/images/pluswhite.svg' className='img-fluid ps-2' />
                                                </label>
                                            </Dropdown.Item>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <label className='BorderBtn p-2 me-0 text-center' title={`Add ${dynamic_brand_text} User`} onClick={(e) => { setIsaddupadtepopup(true); }}>Add {dynamic_brand_text} User
                                    <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="greyBox">
                                <StaffAddUpdate CurrentUsers={Users} setUsers={setUsers} GetAccessDevice={GetAccessDevice} setIsaddupadtepopup={setIsaddupadtepopup}
                                    Users={Users} currentPage={currentPage} LimitForPagination={LimitForPagination} showPagination={showPagination}
                                    setCurrentPage={setCurrentPage} pageRangeCount={pageRangeCount} setColumnNames={setColumnNames} columnNames={columnNames}
                                    selectedIdsAll={selectedIdsAll} SelectedItems={SelectedItems} setSelectedIdsAll={setSelectedIdsAll} setSelectedItems={setSelectedItems}
                                    setCreateGroupModal={setCreateGroupModal} setCreateBatchbuttonVisible={setCreateBatchbuttonVisible} allData={allData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Popup isshow={isaddupadtepopup} size={"md"} title={allData.flag == 1 ? `Add ${dynamic_brand_text} Users` : `Edit ${dynamic_brand_text} Users`}
                closePopup={(e) => {
                    setEmailError(''); setIsaddupadtepopup(false);
                    setAllData({ ...allData, firstname: '', lastname: '', access: 0, email: '', flag: 1, Memberid: 0, File: '' })
                }}
                modalBody={modalBody} handleSave={(e) => allData.flag == 1 ? AddUpdateStaffMember(1) : AddUpdateStaffMember(2)} visibleSaveBtn={true} btnText={allData.flag == 1 ? 'Add' : 'Update'} />

            <Popup isshow={CreateGroupModal} size={"sm"} title={'Create Group'}
                closePopup={(e) => { setGroupName(''); setGrpErrorMsg(false); setCreateGroupModal(false) }}
                modalBody={creategroupmodalbody} handleSave={(e) => CreateGroupCall(e)} visibleSaveBtn={true} btnText={'Create'} />

            <Popup isshow={isDomainpopup} size={"md"} title={'Add Allowed Domains'}
                closePopup={(e) => { setIsDomainpopup(false); GetAccessDevice(null, null, false); setShowAddNewDomain({ ...showAddNewDomain, newDomains: [], newDomainString: "", }) }}
                modalBody={domainmodalbody} handleSave={handleAllowedDomain} visibleSaveBtn={true} btnText={'Save'} />
        </staffdetailscontent.Provider>
    )
}
